import React from "react";
import "./HarGharTirangaPage.css";
import Banner from "../Component/har ghar tiranga.jpeg"; // 🖼️ Replace with your actual banner image

const HarGharTirangaPage = () => {
  return (
    <div className="tiranga-page">
      {/* ✅ Banner Section */}
      <div className="tiranga-banner">
        <img src={Banner} alt="Har Ghar Tiranga CPIT" className="banner-img" />
      </div>

      {/* ✅ Content Section */}
      <div className="tiranga-content">
        <h2>Har Ghar Tiranga Campaign at CPIT</h2>
        <p>
          The <strong>Career Point of Information Technology (CPIT)</strong> proudly celebrated the
          <strong> “Har Ghar Tiranga” </strong> campaign under the banner of
          <strong> Azadi Ka Amrit Mahotsav</strong> — a national initiative to honor the spirit of freedom
          and pay tribute to the heroes of India’s independence. The campaign encouraged every citizen to
          hoist the Indian National Flag at their homes, symbolizing national pride and unity.
        </p>

        <h2>About the Initiative</h2>
        <p>
          The <strong>Har Ghar Tiranga</strong> movement, launched by the Government of India, aims to bring
          the tricolor closer to every Indian’s heart. It inspires citizens to display the National Flag with
          respect and love, reinforcing the message that patriotism lives within every home.
        </p>

        <h2>CPIT’s Celebration of Har Ghar Tiranga</h2>
        <ul>
          <li>🇮🇳 Flag hoisting ceremony conducted at CPIT campus by the Director and faculty members.</li>
          <li>🎓 Students participated in a <strong>Patriotic March</strong> carrying the tricolor across the campus.</li>
          <li>🎤 Cultural programs including <strong>patriotic songs, speeches, and poetry</strong> performed by students.</li>
          <li>🎨 <strong>Poster and Slogan Competitions</strong> highlighting the values of unity and sacrifice.</li>
          <li>📸 “Selfie with Tiranga” campaign organized to spread awareness on social media platforms.</li>
        </ul>

        <h2>Objective of the Program</h2>
        <p>
          The objective of the campaign at CPIT was to instill a sense of pride, patriotism, and
          responsibility among students toward the nation. It aimed to remind every Indian of the
          sacrifices made by freedom fighters and the importance of preserving our national unity and integrity.
        </p>

        <h2>Student Participation</h2>
        <p>
          The event witnessed enthusiastic participation from students, faculty, and staff members.
          Everyone actively contributed to the celebrations by decorating the campus with flags, lights,
          and slogans that reflected India’s vibrant spirit and diversity.
        </p>

        <h2>Message from CPIT</h2>
        <p>
          The <strong>Career Point of Information Technology</strong> encourages every student to carry
          forward the message of “Har Ghar Tiranga” beyond the event — by being proud citizens and
          contributing to India’s growth, innovation, and unity. The flag symbolizes our collective
          identity and the dreams of a progressive nation.
        </p>

        <h2>Conclusion</h2>
        <p>
          The <strong>Har Ghar Tiranga</strong> celebration at CPIT was not just an event — it was a reminder
          of the power of unity and patriotism. By proudly hoisting the tricolor, CPIT reaffirmed its
          commitment to nation-building through education, discipline, and national pride.
        </p>
      </div>
    </div>
  );
};

export default HarGharTirangaPage;
